import i18n from '@/i18n';

export const DRAFTKINGS_PRIVACY_POLICY_URL = 'https://myaccount.draftkings.com/document/privacy';
export const MODELO_PRIVACY_NOTICE_URL = 'https://www.modelousa.com/pages/privacy-policy';
export const MODELO_USER_AGREEMENT_URL = 'https://www.modelousa.com/pages/terms-of-use';

export function getDefaultMarketingConsentCopy() {
  return {
    headline: i18n.t('marketingConsent.headline'),
    subheadline: i18n.t('marketingConsent.subheadline'),
    checkboxPrompt: i18n.t('marketingConsent.checkboxPrompt'),
    eligibilityText: i18n.t('marketingConsent.eligibilityText'),
    footerText: i18n.t('marketingConsent.footerText'),
    buttonText: i18n.t('marketingConsent.buttonText'),
  };
}

/**
 * Whether the landing marketing consent modal should appear for this contest.
 * Default OFF: only enabled when explicitly turned on in admin, or via
 * VITE_PICKEM_MARKETING_CONSENT=1 (staging override). An absent or false
 * style_config flag keeps the modal hidden.
 */
export function shouldShowMarketingConsentModal(
  styleConfig: Record<string, unknown> | undefined
): boolean {
  if (styleConfig?.showMarketingConsentModal === false) return false;
  if (styleConfig?.showMarketingConsentModal === true) return true;
  if (import.meta.env.VITE_PICKEM_MARKETING_CONSENT === '1') return true;
  return false;
}
